import { format } from 'date-fns';

export const DASHBOARD_COURSE_LABELS = {
  whiteCard: 'White Card',
  trafficControl: 'Traffic Controller',
  trafficImplement: 'Traffic Implementer',
  qldWhiteCard: 'QLD White Card',
}

// Course rows feed the calendar, the all-courses class list and the student search.
// Loads stay ordered newest-first so a capped load is the most recent work, not an
// arbitrary slice of document ids, and are cached briefly so tab switches don't refetch.
export const DASHBOARD_COURSE_ROW_LIMIT = 200
export const COURSE_DATA_CACHE_MS = 5 * 60 * 1000
export const MIN_STUDENT_SEARCH_LENGTH = 3

export const DASHBOARD_COURSE_SOURCES = [
  { collectionName: 'eoi', courseTypeKey: 'whiteCard', courseTab: 'White Card', submissionType: 'eoi' },
  { collectionName: 'declaration', courseTypeKey: 'whiteCard', courseTab: 'White Card', submissionType: 'declaration' },
  { collectionName: 'trafficControl', courseTypeKey: 'trafficControl', courseTab: 'Traffic Control', submissionType: 'eoi' },
  { collectionName: 'dec-trafficControl', courseTypeKey: 'trafficControl', courseTab: 'Traffic Control', submissionType: 'declaration' },
  { collectionName: 'trafficImplementation', courseTypeKey: 'trafficImplement', courseTab: 'Traffic Implement', submissionType: 'eoi' },
  { collectionName: 'dec-trafficImplementation', courseTypeKey: 'trafficImplement', courseTab: 'Traffic Implement', submissionType: 'declaration' },
]

export const dashboardCourseRowKey = (row = {}) => `${row.dashboardCourseTab}__${row.submissionType}__${row.id}`

// Forms use title case while saved classes use lowercase delivery labels.
export const dashboardCalendarClassKey = (courseClass = {}) => JSON.stringify([
  courseClass.courseTypeKey,
  courseClass.scheduledDateKey,
  String(courseClass.trainerId || '').trim().toLowerCase(),
  String(courseClass.delivery || '').trim().toLowerCase(),
])

// Turns raw submission documents into the calendar's classes and the rows the
// class groups are built from. Shared by the recent-rows load and the
// calendar's month load so both produce identical ids.
export const buildDashboardCourseData = (sourceResults = [], { role = '', trainerId = '' } = {}) => {
  const groups = new Map()
  const rows = []

  sourceResults.forEach(({ source, docs = [] }) => {
    docs.forEach((row) => {
      const rowData = row.data || {}
      const rawDate = row.classDate ? `${row.classDate}T12:00:00` : row.Created ? row.Created * 1000 : rowData.dateFirstPage || row.dateFirstPage || row.createdAt || ''
      const scheduledDate = new Date(rawDate)
      if (Number.isNaN(scheduledDate.getTime())) return

      const rowTrainerId = rowData.trainerId || row.trainerId || ''
      if (role === 'trainer' && String(rowTrainerId).trim().toLowerCase() !== String(trainerId || '').trim().toLowerCase()) return

      const delivery = rowData.delivery || row.delivery || ''
      const scheduledDateKey = format(scheduledDate, 'yyyy-MM-dd')
      const normalizedTrainerId = String(rowTrainerId).trim().toLowerCase()
      rows.push({
        ...row,
        submissionType: source.submissionType,
        dashboardCourseTab: source.courseTab,
        dashboardCourseTypeKey: source.courseTypeKey,
      })
      const key = `${source.courseTypeKey}-${scheduledDateKey}-${normalizedTrainerId || 'unassigned'}-${delivery || 'delivery'}`
      if (!groups.has(key)) {
        groups.set(key, {
          id: row.classId || rowData.classId || `legacy-${source.courseTypeKey}__${normalizedTrainerId || 'trainer'}__${scheduledDateKey}__${delivery || 'delivery'}`,
          courseTypeKey: source.courseTypeKey,
          courseName: DASHBOARD_COURSE_LABELS[source.courseTypeKey],
          trainerId: rowTrainerId,
          scheduledDate: scheduledDate.toISOString(),
          scheduledDateKey,
          delivery,
          source: 'enrolment',
        })
      }
    })
  })

  return { rows, classes: [...groups.values()] }
}
